"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyOrder = void 0;
const applyOrder = (data, prop, order) => order.map(orderValue => data.find(x => x[prop] === orderValue));
exports.applyOrder = applyOrder;